import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProfilePreviewReferencesComponent } from "./profile-preview-references.component";
import { NzListModule } from "ng-zorro-antd/list";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { TranslateModule } from "@ngx-translate/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzGridModule } from "ng-zorro-antd/grid";

@NgModule({
  declarations: [ProfilePreviewReferencesComponent],
  imports: [
    CommonModule,
    NzListModule,
    NzDividerModule,
    TranslateModule,
    NzButtonModule,
    NzToolTipModule,
    NzIconModule,
    NzCardModule,
    NzGridModule,
  ],
  exports: [ProfilePreviewReferencesComponent],
})
export class ProfilePreviewReferencesModule {}
